import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    Paper,
    Typography,
    CircularProgress,
    Button,
    Autocomplete,
    TextField
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Multiselect from 'multiselect-react-dropdown';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import './reports.css'
import { ExportCsvButton } from '../../components/Buttons/ExportCsvButton';

const OutOfGradeSummaryReport = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(moment().startOf('month').toDate());
    const [toDate, setToDate] = useState(moment().toDate());
    const [employees, setEmployees] = useState([]);
    const [selectedEmpCode, setSelectedEmpCode] = useState([]);
    const [selectedEmp, setSelectedEmp] = useState([])
    const [absentCodes, setAbsentCodes] = useState([]);
    const [selectedAbsentCode, setSelectedAbsentCode] = useState(null);

    const shiftColumns = [
        {
            field: 'shift_date',
            headerName: 'Shift Date',
            flex: 1,
            valueGetter: params =>
                params?.row?.shift_date
                    ? moment(params.row.shift_date).format('MM/DD/YYYY')
                    : ''
        },
        { field: 'shift_code', headerName: 'Shift Code', flex: 1 },
        { field: 'shift_name', headerName: 'Shift Name', flex: 1 },
        { field: 'absent_code', headerName: 'Absent Code', flex: 1 },
        { field: 'start_time', headerName: 'Start Time', flex: 1 },
        { field: 'end_time', headerName: 'End Time', flex: 1 },
        { field: 'hours_worked', headerName: 'Hours', flex: 1 }
    ];

    const backFunction = () => {
        navigate('/firehouse/reports');
    };

    const getEmployeeSwapReport = (method) => {
        setLoading(true);
        var temp = []
        selectedEmp.map((a) => {
            temp.push(a.value)
        })
        const payload = {
            start_date: moment(fromDate).format('YYYY-MM-DD'),
            end_date: moment(toDate).format('YYYY-MM-DD'),
            emp_codes: selectedEmp && selectedEmp?.length > 0 ? temp : '',
            method
        };

        if (selectedAbsentCode) {
            payload.absent_code = selectedAbsentCode.value;
        }

        if (selectedEmpCode.length > 0) {
            payload.emp_codes = selectedEmpCode.map(emp => emp.Emp_Code);
        }

        ApiService.post('/reports/oog-summary-report', payload)
            .then((response) => {
                setLoading(false);

                if (!method) {
                    setRows(Array.isArray(response.data) ? response.data : []);
                    return;
                }

                if (method === 'csv') {
                    const blob = new Blob(
                        [response],
                        { type: 'text/csv;charset=utf-8;' }
                    );

                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');

                    link.href = url;
                    link.download = 'volunteer-report.csv';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    return;
                }

                if (method === 'pdf') {
                    const pdfUrl = response?.pdf_url;

                    if (pdfUrl) {
                        window.open(pdfUrl, '_blank');
                    } else {
                        toast.error('PDF URL not found');
                    }
                    return;
                }

            })
            .catch(err => {
                setLoading(false);
                toast.error(
                    err?.response?.data?.message || 'Failed to fetch data'
                );
            });
    };

    useEffect(() => {
        ApiService.get("/absentCodesConditions?condition=ALLOW_SUMMARY_REPORT")
            .then(({ data }) => {
                const codesObj = data?.data || {};

                const options = Object.keys(codesObj).map(code => ({
                    label: code,
                    value: code
                }));

                setAbsentCodes(options);
            })
            .catch(() => {
                toast.error("Failed to load absent codes");
            });
    }, []);

    useEffect(() => {
        getEmployeeSwapReport();
        loadEmployees()
    }, []);

    const loadEmployees = () => {
        setLoading(true);
        ApiService.get('/employeeToSwap')
            .then(({ data }) => {
                var tempArr = []
                data.map((emp) => {
                    var obj = {
                        label: `${emp.EA_Rank} ${emp.fullName}`,
                        value: emp.Emp_Code
                    }
                    tempArr.push(obj)
                })
                setEmployees(tempArr)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const filteredRows =
        selectedEmpCode.length > 0
            ? rows.filter(row =>
                selectedEmpCode.some(emp =>
                    emp.Emp_Code === row.Emp_Code ||
                    emp.Emp_Code === row.Orig_Emp_Code
                )
            )
            : rows;

    const getTotalHoursRow = (shifts = []) => {
        const total = shifts.reduce(
            (sum, shift) => sum + Number(shift.hours_worked || 0),
            0
        );

        return {
            id: 'total-row',
            shift_date: '',
            shift_code: '',
            shift_name: '',
            start_time: '',
            end_time: 'TOTAL HOURS',
            hours_worked: total
        };
    };

    return (
        <Paper className="p-4" sx={{ marginTop: '1rem' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    marginBottom: '25px'
                }}
            >
                {/* Back button */}
                <Button onClick={backFunction} sx={{ color: '#212529', minWidth: 'auto' }} style={{ padding: '0px' }}>
                    <ArrowBackIosIcon fontSize="small" />
                </Button>

                {/* Title */}
                <Typography variant="h5">
                    Out of Grade Summary Report
                </Typography>

                {/* Right-aligned actions */}
                {filteredRows.length > 0 && (
                    <Box sx={{ marginLeft: 'auto', display: 'flex', gap: 1 }}>
                        <ExportCsvButton
                            onClick={() => getEmployeeSwapReport('csv')}
                            text={'Export CSV'}
                        />
                        <ExportCsvButton
                            onClick={() => getEmployeeSwapReport('pdf')}
                            text={'Export PDF'}
                        />
                    </Box>
                )}
            </Box>

            <Grid
                container
                spacing={2}
                alignItems="flex-end"
                className="mt-1"
            >
                {/* From */}
                <Grid item xs={12} sm={6} md={2.5} className='d-grid'>
                    <label className='my-1'>From</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <ButtonDatePicker
                            className='w-100'
                            label={moment(fromDate).format('MM-DD-YYYY')}
                            value={fromDate}
                            onChange={(e) => setFromDate(e)}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* To */}
                <Grid item xs={12} sm={6} md={2.5} className='d-grid'>
                    <label className='my-1'>To</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <ButtonDatePicker
                            className='w-100'
                            label={moment(toDate).format('MM-DD-YYYY')}
                            value={toDate}
                            onChange={(e) => setToDate(e)}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* Employees */}
                <Grid item xs={12} md={3}>
                    <label className='my-1'>Employees</label>
                    <Multiselect
                        displayValue="label"
                        options={[{ label: 'All', value: '' }, ...employees]}
                        showCheckbox
                        showArrow
                        placeholder="Select Employees"
                        selectedValues={selectedEmp}
                        onSelect={(list, item) =>
                            setSelectedEmp(
                                item.value === ''
                                    ? []
                                    : list.filter(i => i.value !== '')
                            )
                        }
                        onRemove={(list) =>
                            setSelectedEmp(list.filter(i => i.value !== ''))
                        }
                    />
                </Grid>

                {/* Absent Codes */}
                <Grid item xs={12} md={2}>
                    <label className='my-1'>Absent Codes</label>
                    <Autocomplete
                        options={absentCodes}
                        getOptionLabel={(option) => option.label}
                        value={selectedAbsentCode}
                        onChange={(e, val) => setSelectedAbsentCode(val)}
                        isOptionEqualToValue={(option, value) =>
                            option?.value === value?.value
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Absent Code"
                                size="small"
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: "48px",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center"
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>

                {/* Filter Button */}
                <Grid item xs={12} md={2} sx={{ display: 'flex', flexDirection: 'column', marginBottom: '7px' }}>
                    <Button
                        variant="contained"
                        onClick={() => getEmployeeSwapReport()}
                        sx={{ whiteSpace: 'nowrap', height: '38px', width: '100px' }}
                    >
                        Find
                    </Button>
                </Grid>
            </Grid>



            {loading && (
                <Box className="d-flex justify-content-center mt-5">
                    <CircularProgress />
                </Box>
            )}

            {!loading && filteredRows.length === 0 && (
                <Box
                    className="d-flex flex-column align-items-center justify-content-center"
                    sx={{ height: 300 }}
                >
                    <img src="/images/blur-logo.png" height={180} alt="No data" />
                    <Typography sx={{ mt: 2, color: '#555' }}>
                        No Data Found
                    </Typography>
                </Box>
            )}

            {!loading && filteredRows.length > 0 && (
                <div>
                    {filteredRows.map((emp, index) => {
                        const shiftRows = emp.shifts.map((shift, i) => ({
                            id: i,
                            ...shift
                        }));

                        return (
                            <CollapseComponent
                                key={emp.emp_code || index}
                                name={`${emp.employee_name} (${emp.emp_code})`}
                                rows={[...shiftRows, getTotalHoursRow(emp.shifts)]}
                                columns={shiftColumns}
                                checkboxSelection={false}
                                open={true}
                                height="auto"
                                showHeader={true}
                            />
                        );
                    })}
                </div>
            )}
        </Paper>
    );
};

export default OutOfGradeSummaryReport;